import { createAction, createAsyncAction } from "typesafe-actions";

import type { CrmIntegrationProvider } from "app/pages/sales-intelligence/domain/crm-integration/types/provider";
import type { LeadsType } from "app/pages/sales-intelligence/domain/leads/types/lead";

import type { AccountExportPreview, AccountsExportBulkAction, AccountsExportPhase } from "../types";

export const initAccountsExport = createAction("@@si/accounts-crm-export/INIT")<{
    integration: CrmIntegrationProvider;
    leadsType: LeadsType;
    countries: readonly number[];
    listId?: string;
}>();

export const setAccountsExportPhase = createAction("@@si/accounts-crm-export/SET_PHASE")<AccountsExportPhase>();

export const fetchAccountsPreviewAsync = createAsyncAction(
    "@@si/accounts-crm-export/FETCH_PREVIEW_REQUEST",
    "@@si/accounts-crm-export/FETCH_PREVIEW_SUCCESS",
    "@@si/accounts-crm-export/FETCH_PREVIEW_FAILURE",
)<void, AccountExportPreview[], unknown>();

export const accountPreviewChanged = createAction("@@si/accounts-crm-export/PREVIEW_CHANGED")<AccountExportPreview>();

export const accountPreviewDeleted = createAction("@@si/accounts-crm-export/PREVIEW_DELETED")<string>();

export const applyBulkAccountsSelection =
    createAction("@@si/accounts-crm-export/APPLY_BULK")<AccountsExportBulkAction>();

export const resetAccountsExport = createAction("@@si/accounts-crm-export/RESET")();
